import _ from 'underscore';

const operators = ['eq', 'neq', 'gt', 'gte', 'lt', 'lte'];

// For those columns which UI use its mutiplied value as display value,
// we need to restore the value for MT to filter.
export function updateOdataOptionsForMultiplied(options) {
  const optionsCopy = options || { custom: {} };

  _.extendOwn(optionsCopy.custom, {
    // Value stored as millisecond in MT but displayed as second in UI.
    // We need to mutiply it by 1000 to make sure MT gets the correct value.
    'PerformanceMetrics/TotalWatchTimeInMS': _.object(
      operators,
      operators.map(op => val => `PerformanceMetrics/TotalWatchTimeInMS ${op} ${val * 1000}`)
    ),
  });

  return optionsCopy;
}
